import React, { useEffect, useMemo } from "react";
import style from "./index.module.scss";
import { Badge, Button, Icon, Select } from "antd";
import Config from "../../../../config";
import useCurrentDate from "../../../../utils/useCurrentDate";
import moment from "moment";
import { Link } from "react-router-dom";
import { newEvaluationStatus } from "../../../../service/evaluate";
import useRequest from "../../../../utils/useRequest";

interface WeekPickerProps {
    week: number;
    currentWeek: number;
    onChange: (week: number) => void;
    showList?: boolean;
}

export default function WeekPicker({
    week,
    currentWeek,
    onChange,
    showList = true
}: WeekPickerProps) {
    // 第一次渲染时触发下onChange
    useEffect(() => onChange(week), []);
    const [isEvaluation] = useRequest(newEvaluationStatus);

    const { startDate, endDate, time } = useCurrentDate();

    // 当前时间是否在所选择学期内
    const isCurrentBatch = useMemo(
        () => time.isBetween(moment(startDate), moment(endDate)),
        [startDate, endDate, time]
    );

    return (
        <div className={style.root}>
            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => onChange(Math.max(week - 1, 1))}
                disabled={week === 1}>
                <Icon type="left" className={style.icon} />
            </Button>

            <Select
                value={week}
                onChange={onChange}
                className={style.select}
                dropdownClassName={style.dropdown}>
                {new Array(Config.MaxWeek).fill(1).map((_, index) => (
                    // @ts-ignore
                    <Select.Option value={index + 1} key={index}>
                        第&nbsp;&nbsp;{index + 1}&nbsp;&nbsp;周
                    </Select.Option>
                ))}
            </Select>

            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => onChange(Math.min(week + 1, Config.MaxWeek))}
                disabled={week === Config.MaxWeek}>
                <Icon type="right" className={style.icon} />
            </Button>

            <div className={style.count}>共{Config.MaxWeek}周</div>

            <Button
                type="link"
                className={style.reset}
                onClick={() => onChange(currentWeek)}
                disabled={!isCurrentBatch}>
                回到今天
            </Button>
            {showList && (
                <Link className={style.courseList} to={"/course/list"}>
                    <Badge dot count={isEvaluation ? 1 : 0}>
                        <Icon type="menu-unfold" />
                        <span className={style.ca}>课程列表</span>
                    </Badge>
                </Link>
            )}
        </div>
    );
}
